import SubmitQuestion from "../component/SubmitQuestion";
import {useContext} from "react";
import {Context} from "../component/context";

export const Survey = () => {
    const {problems, setProblems} = useContext(Context);

    return <div className='w-full  h-screen overflow-x-scroll hidden templates' id='survey'>
        <SubmitQuestion title='설문' setProblems={setProblems} problems={problems}/>
    </div>
}